module.exports = __webpack_public_path__ + "img/background_tirion.b2b76311.png";